export const formatAmount = (amount) => {
  const rounded = Math.round(amount);
  const str = rounded.toString();
  return str.length > 5 ? str.slice(0, 5) + '...' : str;
};
